import { render, staticRenderFns } from "./fold1.vue?vue&type=template&id=2f23deab&scoped=true&"
import script from "./fold1.vue?vue&type=script&lang=js&"
export * from "./fold1.vue?vue&type=script&lang=js&"
import style0 from "./fold1.vue?vue&type=style&index=0&id=2f23deab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f23deab",
  null
  
)

export default component.exports